<template>
  <div class="content">
    <NavBar style="padding-bottom: 100px;"></NavBar>

    <md-app md-mode="reveal">
      <md-app-content>
        <notifications></notifications>
        <dashboard-content></dashboard-content>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import NavBar from "../../components/NavBar.vue";

export default {
  components: {
    DashboardContent,
    ContentFooter,
    NavBar
  },
  data () {
    return {
      notifications: {
        topCenter: false
      }
    }
  },

  methods: {
    ...mapActions(["SET_LOGOUT", "SET_SEARCH_REQUEST", 'SET_MESSAGE']),
    logOut() {
      this.SET_LOGOUT();
      this.$router.push("home");
    }
  },
  computed: {
    ...mapGetters(["is_authenticated", "is_staff", "notification"])
  },
  watch:{
    notification(notification) {
      var type = 'info'
      if (notification.status >= 299) {
        type = 'danger'
      }
      this.$notify({
        message: notification.message,
        icon: 'add_alert',
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type
      })
    }
  }
};
</script>
